<form [formGroup]="wrongAddressForm" (ngSubmit)="reportAddress()" *ngIf="showModal">
  <app-modal
      [attr.data-test]="'button-reportWrongAddress'"
      [open]="showModal"
      [id]="'wrongAddressModal'"
      title="{{ 'checkout-delivery-details.report-wrong-address' | translate }}"
      (crossClick)="resetForm()"
      (outsideClick)="resetForm()">
    <ng-container ngProjectAs="[slot][body]">
      <div class="loader__overlay" *ngIf="loading">
        <div class="loader__content">
          <div class="loading-animation"></div>
        </div>
      </div>
      <div class="row">
        <app-textfield
            class="col-12"
            [form]="wrongAddressForm"
            [modelValue]="wrongAddressForm.value.deliveryAddress"
            [inputName]="'deliveryAddress'"
            label="{{ title | translate }}"
            [isRequired]="true"
            [readOnly]="true"
            [loading]="addressesLoading">
        </app-textfield>
      </div>
      <div class="row">
        <app-textarea
            class="col-12"
            [form]="wrongAddressForm"
            [modelValue]="wrongAddressForm.value.comment"
            [rows]="3"
            [cssStyles]="{wrapper: 'text-area-comment'}"
            [inputName]="'comment'"
            [maxLength]="maxLengthComment"
            label="{{ 'checkout-delivery-details.comment' | translate }}"
            [isRequired]="true"
            trim
            trimWhitespaces>
        </app-textarea>
        <div class="form-alerts">
          <ng-container *ngIf="wrongAddressForm.value.comment">
            <small class="textfield__hint">
              {{ wrongAddressForm.value.comment.length }}/{{ maxLengthComment }}
            </small>
          </ng-container>
        </div>
      </div>
    </ng-container>
    <ng-container ngProjectAs="[slot][footer]">
      <button
          type="reset"
          class="button button"
          data-dismiss="modal-dialog"
          (click)="resetForm()">
        {{ 'checkout-delivery-details.cancel' | translate }}
      </button>
      <button
          type="submit"
          class="button button--primary"
          data-dismiss="modal-dialog"
          [disabled]="!formIsValid()"
          (click)="showLoader()">
        {{ 'checkout-delivery-details.send-wrong-address' | translate }}
      </button>
    </ng-container>
  </app-modal>
</form>
